import { z } from "zod";

export const patchNewHireWorkerStatusRequestSchema = z.object({
  worker_id: z.string(),
  record_id: z.string(),
  status: z.string(),
});

export type TPatchNewHireWorkerStatusRequest = z.infer<
  typeof patchNewHireWorkerStatusRequestSchema
>;

export const patchNewHireWorkerStatusResponseSchema = z.object({
  success: z.boolean(),
  data: z.unknown(),
});

export type TPatchNewHireWorkerStatusResponse = z.infer<
  typeof patchNewHireWorkerStatusResponseSchema
>;
